import { inject, Injectable } from '@angular/core';
import { DEFAULT_THEME, ThemeModel } from '../models/theme.model';
import { GlobalDataService } from './global.data.service';

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	private theme: ThemeModel | null = null;

	private globalData = inject(GlobalDataService);

	patchTheme(partialTheme: Partial<ThemeModel>) {
		this.applyThemeToCss(DEFAULT_THEME);

		this.theme = {
			...DEFAULT_THEME,
			...this.theme,
			...partialTheme,
		};
		this.globalData.pwaTheme$.next(this.theme);

		this.applyThemeToCss(this.theme);
	}

	applyThemeToCss(theme: ThemeModel) {
		this.theme = theme;

		const root = document.documentElement;

		root.style.setProperty('--color-primary', theme.primaryColor!);
		root.style.setProperty('--color-secondary', theme.secondaryColor!);
		root.style.setProperty('--color-background', theme.backgroundColor!);
		root.style.setProperty('--color-accent', theme.accentColor!);
		root.style.setProperty('--color-action', theme.actionColor!);
		root.style.setProperty('--color-success', theme.successColor!);
		root.style.setProperty('--color-warning', theme.warningColor!);
		root.style.setProperty('--color-danger', theme.dangerColor!);
		root.style.setProperty('--color-logo-cover', theme.logoCoverColor!);
		root.style.setProperty('--color-primary-font', theme.primaryFontColor!);
		root.style.setProperty('--color-secondary-font', theme.secondaryFontColor!);
		root.style.setProperty('--color-btn-action', theme.btnActionColor!);
		root.style.setProperty('--color-btn-font-action', theme.btnFontActionColor!);
		root.style.setProperty('--color-highlight-font', theme.highlightFontColor!);
	}
}
